module.exports = __webpack_public_path__ + "45ddad0beb6245681f21399c50e92d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/3.jpg
// module id = 303
// module chunks = 0